export enum Actions {
    DISPLAY_CV = "DisplayCv",
    DISPLAY_MOTIVATION_LETTER = "DisplayMotivationLetter",
    DISPLAY_CONTACT = "DisplayContact",
    DISPLAY_NOTES = "DisplayNotes",
}
